import { getPartnerIdFromChatId } from "@/firebase/utils";
import { ActionTypes } from "@/store";
import { ButtonObject } from "@/types/button";
import { ChatSettingsScreenEnum } from "@/types/chat";
import { computed } from "vue";
import { ChatSettingsDetailsPropsObject } from "../ChatSettingsDetails";
import { useGetChatSettingsCommonProperties } from "../useGetChatSettingsCommonProperties";
import { unblockUserWarningPoints } from "./unblockUserWarningPoints";
import { getPartnerFromSelectedChat } from "@/utils/users";

export const useGetChatSettingsUnblockUserProperties = () => {
  const { authId, selectedChatId, route, router, dispatch } =
    useGetChatSettingsCommonProperties();
  const partner = getPartnerFromSelectedChat();

  const unblockUserProperties = computed<ChatSettingsDetailsPropsObject>(() => {
    return {
      type: ChatSettingsScreenEnum.UnblockUser,
      primaryButton: primaryButton.value,
      imageSrc: partner?.picture,
      warningPoints: unblockUserWarningPoints,
    };
  });
  const primaryButton = computed<ButtonObject>(() => {
    return {
      handleClick: handlePrimaryButtonClick,
    };
  });

  const handlePrimaryButtonClick = async (): Promise<void> => {
    const chatId = selectedChatId.value ?? (route.params.chat_id as string);
    const partnerId = getPartnerIdFromChatId(authId.value, chatId);
    await dispatch(ActionTypes.UNBLOCK_USER, { partnerId, chatId });
    router.back();
  };

  return { unblockUserProperties };
};
